// src/pages/Competitions/ListingCompetitions.jsx
import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useScrollToTop from "../../hooks/useScrollToTop";
import ScrollIndicator from "./../../hooks/ScrollIndicator";

import { useCompetitionsListing } from "./useCompetitionsListing";

import CompetitionsAdminHeader from "./components/CompetitionsAdminHeader";
import CompetitionsFiltersBar from "./components/CompetitionsFiltersBar";
import CompetitionsPanel from "./components/CompetitionsPanel";
import CompetitionDrawer from "./components/CompetitionDrawer";
import CompetitionsPagination from "./components/CompetitionsPagination";

const PAGE =
  "min-h-screen bg-slate-50 text-slate-900 dark:bg-slate-950 dark:text-slate-50";

export default function ListingCompetitions() {
  useScrollToTop();

  const {
    filteredCompetitions = [],
    pageRows = [],
    stats = {
      total: 0,
      filtered: 0,
      active: 0,
      publicCount: 0,
      upcoming: 0,
    },
    organizerMap = {},
    statsMap = {},
    organizerOptions = [],
    selectedCompetition,
    setSelectedCompetition,

    loading,

    q,
    setQ,
    status,
    setStatus,
    organizerFilter,
    setOrganizerFilter,
    onlyActive,
    setOnlyActive,
    onlyPublic,
    setOnlyPublic,
    sort,
    setSort,

    page,
    setPage,
    pageSize,
    setPageSize,
    pageCount,

    loadCompetitions,
    exportCSV,
    resetFilters,
  } = useCompetitionsListing();

  const selectedOrganizer = selectedCompetition
    ? organizerMap[selectedCompetition.organisateur_competition]
    : null;

  const selectedStats = selectedCompetition
    ? statsMap[selectedCompetition.id]
    : null;

  return (
    <div className={PAGE}>
      <ScrollIndicator />

      <main className="mx-auto w-full max-w-[1280px] px-3 pb-12 pt-[120px] sm:px-5 md:pt-[145px]">
        <div className="space-y-6">
          <CompetitionsAdminHeader
            stats={stats}
            loading={loading}
            onRefresh={loadCompetitions}
          />

          <CompetitionsFiltersBar
            q={q}
            setQ={(value) => {
              setQ(value);
              setPage(1);
            }}
            status={status}
            setStatus={(value) => {
              setStatus(value);
              setPage(1);
            }}
            organizerFilter={organizerFilter || "all"}
            setOrganizerFilter={(value) => {
              setOrganizerFilter(value);
              setPage(1);
            }}
            organizerOptions={organizerOptions}
            onlyActive={onlyActive}
            setOnlyActive={(value) => {
              setOnlyActive(value);
              setPage(1);
            }}
            onlyPublic={onlyPublic}
            setOnlyPublic={(value) => {
              setOnlyPublic(value);
              setPage(1);
            }}
            sort={sort}
            setSort={(value) => {
              setSort(value);
              setPage(1);
            }}
            onExport={exportCSV}
            onResetFilters={resetFilters}
          />

          <CompetitionsPanel
            rows={pageRows}
            loading={loading}
            searchTerm={q}
            organizerMap={organizerMap}
            statsMap={statsMap}
            onOpenDetails={setSelectedCompetition}
          />

          <CompetitionsPagination
            page={page}
            setPage={setPage}
            pageCount={pageCount}
            pageSize={pageSize}
            setPageSize={setPageSize}
            total={filteredCompetitions.length}
          />

          <div className="rounded-[24px] border border-slate-200 bg-white p-4 text-sm text-slate-600 shadow-sm dark:border-slate-800 dark:bg-slate-900 dark:text-slate-300">
            Total : <strong>{stats.total}</strong> • Affichées :{" "}
            <strong>{stats.filtered}</strong> • Actives :{" "}
            <strong>{stats.active}</strong> • Publiques :{" "}
            <strong>{stats.publicCount}</strong> • À venir :{" "}
            <strong>{stats.upcoming}</strong>
          </div>
        </div>
      </main>

      <CompetitionDrawer
        competition={selectedCompetition}
        organizer={selectedOrganizer}
        stats={selectedStats}
        onClose={() => setSelectedCompetition(null)}
      />

      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
}
